import { isMobileWidth } from '../base/dom-utils.js';

// Collapse panels by default in mobile
if (isMobileWidth()) {
  $('.brand-bar-panel .panel-collapse.in').collapse();
}
